$(document).ready(function(){

  $(document).on('click', '.btn-checkout', function(e){
    if( $('.free_gift_bar .add_single').length || $('.free_gift_bar #openpopup').length ){
      if( !$('.free_gift_bar').hasClass('missed')){
        e.preventDefault();
        $('.free_gift_bar').addClass('missed');
        $('<p class="mb-0 missed text-center small">'+ shop_config.missed_gift +'</p>').insertBefore('.free_gift_bar');
      } else{
        $('.btn-checkout').html('<div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem"><span class="visually-hidden">Loading...</span></div>');
      }
    } else{
      $('.btn-checkout').html('<div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem"><span class="visually-hidden">Loading...</span></div>');
    }
  });
  
  if (typeof URLSearchParams !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    params.delete('_gl');
  }
  $('body').on('click', '#openpopup', function(){
    $(this).magnificPopup({
      type:'inline',
      items: {
        src: '#free_gift_selection'
      },
      mainClass: 'freegift_popup',
      preloader: false,
      removalDelay: 500,
      callbacks: {
        beforeOpen: function() {
          // this.st.mainClass = this.st.el.attr('data-effect');
          if (document.querySelector('#offcanvas-cart')) {
            bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').hide()
          }
          $('body').addClass('hide_scroll');
        },
        open: function() {
          $('#free_gift_selection .gift_product .includes').matchHeight();
        },
        close: function() {
          $('body').removeClass('hide_scroll');
          $('#free_gift_selection .config_product').hide();
          $('#free_gift_selection .content').show();
        }
      },
    }).magnificPopup('open');
  });

  // back button
  $('body').on('click', '.back span', function(){
    $('#free_gift_selection .config_product').fadeOut();
      setTimeout(function(){
        $('#free_gift_selection .content').fadeIn();
      }, 400);
  });

  $('body').on('click', '.gift_product .btn', function(){
    if( $(this).attr('type') == 'simple' ){
      push_to_queue($(this).attr('variant_id'), 1, {_free_gift: "true"});
      Shopify.moveAlong();
      $.magnificPopup.close();
    } else{
      let handle = $(this).attr('handle');
      $('#free_gift_selection .content').fadeOut();
      setTimeout(function(){
        $('.config_product[data-handle="'+ handle +'"]').fadeIn().css('display', 'flex');
      }, 400);
      
    }
  });

  $('body').on('change', '.freegift input[type="radio"]', function(){

    var fg_handle = $(this).parents('.freegift').data('handle');
    var freegift_variant = '';
    $('.option-wrapper').removeClass('active');
    $(this).parents('.option-wrapper').addClass('active');

    $(this).parents('.freegift').find('input[type="radio"]:checked').each(function(i){
      if( $(this).parents('.freegift').find('input[type="radio"]:checked').length <= 1 ){
        freegift_variant += $(this).val();
      } else{
        freegift_variant += $(this).val() + ' / ';
      }
    });
    var chosen = $(this).val();

    var all_similar = $('#'+ fg_handle +'_variants option').filter(function(){
      var option = $(this).text();
      return ( option.includes(chosen) && $(this).attr('available') == 'true' );
    });
    
    if( $(this).parents('.freegift').find('.option-wrapper').length <= 1 ){ // if ONLY one option to choose from
      $(this).parents('.freegift').find('.option-wrapper .bundle-option .option').find('input').prop('disabled', 'disabled');
      $(this).parents('.freegift').find('select option').each(function(){
        if( $(this).attr('available') == 'true' ){
          $('.freegift .option-wrapper .bundle-option .option').find('input[value*="'+ $(this).text() +'"]').prop('disabled', false);
        }
      });
    } else{
      $(this).parents('.freegift').find('.option-wrapper:not(.active) .bundle-option .option').find('input').prop('disabled', 'disabled');
      var value = [];
      $(all_similar).each(function(){
        var split = $.trim(this.innerText).toString().split(' / ');
        $(split).each(function(index, obj){
          value.push(obj);
        });
      });
      var available_options = value.filter(unique);

      $(available_options).each(function(index, innerval){
        // console.log( innerval );
        $('.freegift .option-wrapper .bundle-option .option').find('input[value*="'+ innerval +'"]').prop('disabled', false);
      });
    }
    if( $(this).parent('.option').hasClass('colour') ){
      $('h3.colour_title .selected').empty().prepend('- '+ $(this).val() );
    }

    if( $(this).parents('.freegift').find('input[type="radio"]:checked').length <= 1 ){ // simple variants, one selection
      var selected_freegift = $(this).parents('.freegift').find('select option[data-val="'+ freegift_variant +'"]').val();
    }else{
      var selected_freegift = $(this).parents('.freegift').find('select option[data-val="'+ freegift_variant.slice(0,-3) +'"]').val();
    }
    $('#'+ fg_handle +'_variants').val( selected_freegift );

    $('.config_product[data-handle="'+ fg_handle +'"] .image img, .single_free .image img').attr('src',  $('#'+ fg_handle +'_variants option:selected').attr('image') );

    $('.button_holder').fadeIn();

  });

  $('body').on('click', '.addbtn', function(){
    var fg_handle = $(this).parents('.freegift').data('handle');
    var freegift = $('select#'+ fg_handle +'_variants').val();

    push_to_queue(freegift, 1, {_free_gift: "true"});
    Shopify.moveAlong();

    $.magnificPopup.close();
  });

});